<template>
  <div class="go-top">
    <div class="ul" v-if="popShow">
      <!-- <div class="li">
        <img class="li-img" src="@/assets/images/phone.png" alt="">
        <span>电话联系</span>
      </div> -->
      <Poptip class="li" placement="right">
        <div class="li">
          <img class="li-img" src="@/assets/images/phone.png" alt="">
          <span>电话联系</span>
        </div>
        <div class="qr-img" slot="content">
          <!-- <img class="img" src="@/assets/images/go-top/erwm-jyqkfu.png" alt=""> -->
          <span>400-900-9355</span>
        </div>
      </Poptip>
      <Poptip class="li" placement="right">
        <div class="li">
          <img class="li-img" src="@/assets/images/customer_service.png" alt="">
          <span>在线客服</span>
        </div>
        <div class="qr-img" slot="content">
          <img class="img" src="@/assets/images/go-top/erwm-jyqkfu.png" alt="">
          <span>扫一扫专属客服为您服务</span>
        </div>
      </Poptip>
    </div>
    <div class="li-top" @click="topClick" v-if="isShow">
      <i class="iconfont icon-pullup01"></i>
      <span>返回顶部</span>
    </div>
    <MakeAppointment :modalType="modalType" @modalOff="modalOff" :breadth="670"></MakeAppointment>
  </div>
</template>
<script>
export default {
  name: 'goTop',
  components: {
    MakeAppointment: resolve => (require(['@/views/components/confirm-modal/make-appointment.vue'], resolve)), // 立即预约
  },
  props: {
    modalMake: {
      type: [Boolean],
      default: false
    },
    popShow: {
      type: [Boolean],
      default: true
    },
  },
  watch: {
    modalMake (val) {
      if (val) {
        this.experienceClick(2)
        this.$emit('modalClick', false)
      }
    }
  },
  data () {
    return {
      isShow: false,
      scrollTop: 0,
      modalType: false
    }
  },
  mounted () {
    window.addEventListener("scroll", this.getScrollTop);
  },
  methods: {
    modalOff (val) {
      if (!val) {
        this.modalType = false
      }
    },
    experienceClick(val) {
      if (val == 1) {
        // let url = `${process.env.VUE_APP_SSO_LOGIN_PATH}/login`
        // window.open(url, '_blank');
        this.mixCommon.ssoLoginPath('jyqUrl', 'login')
      } else if (val == 2) {
        this.modalType = true
      }
    },
    topClick() {
      this.$store.commit('set_topScroll', true)
    },
    // 监听滚动条
    getScrollTop(e) {
      let that = this; // 防止this指向问题
      this.scrollTop =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop;
      if (that.scrollTop > 500) {
        that.isShow = true;
      } else {
        that.isShow = false;
      }
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScrollTop);
  }
}
</script>
<style lang="less" scoped>
.go-top {
    position: fixed;
    top: 25rem;
    right: 13.8rem;
    z-index: 99;
    .ul {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 4.1rem 1.6rem 4.5rem 1.6rem;
      background: linear-gradient(0deg, #006EFF, #3A8EFF);
      box-shadow: 0rem 0rem 1.8rem 0rem rgba(156,156,156,0.42);
      border-radius: 4.4rem;
      .li {
        cursor: pointer;
        width: 5.6rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .li-img {
          width: 3.5rem;
          height: 3.4rem;
        }
        span {
          margin-top: 1.3rem;
          font-size: 1.4rem;
          font-weight: 500;
          color: #FFFEFE;
          white-space: nowrap;
        }
        .qr-img {
          width: 100%;
          min-width: 120px;
          display: flex;
          flex-direction: column;
          align-items: center;
          span {
            margin: 0;
            font-size: 2rem;
            font-weight: 500;
            color: #000;
          }

        }
      }

      .li:nth-child(2) {
        border-top: .1rem solid rgba(255, 255, 255, 0.42);
        padding: 3.6rem 0 0;
        margin: 3.1rem 0 0;
        .li-img {
          width: 3.3rem;
          height: 3.6rem;
        }
        .qr-img {
          width: 100%;
          min-width: 120px;
          display: flex;
          flex-direction: column;
          align-items: center;
          .img {
            width: 10.5rem;
            min-width: 100px;
            height: 10.5rem;
            min-height: 100px;
          }
          span {
            font-size: 1.4rem;
            font-weight: 500;
            color: #000;
          }

        }
      }
    }
    .li-top {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 8.8rem;
      height: 8.8rem;
      background: #FFFFFF;
      box-shadow: 0rem 0rem 1rem 0rem rgba(156,156,156,0.32);
      border-radius: 4.4rem;
      margin-top: 1.9rem;
      i {
        font-size: 2.8rem;
        font-weight: 500;
        color: #888888;
        line-height: 1;
      }
      span {
        font-size: 1.4rem;
        font-weight: 500;
        color: #888888;
      }
    }
  }
</style>